import { render, staticRenderFns } from "./newStandard.vue?vue&type=template&id=075e9908&scoped=true"
import script from "./newStandard.vue?vue&type=script&lang=js"
export * from "./newStandard.vue?vue&type=script&lang=js"
import style0 from "./newStandard.vue?vue&type=style&index=0&id=075e9908&prod&lang=scss&scoped=true"
import style1 from "./newStandard.vue?vue&type=style&index=1&id=075e9908&prod&lang=css"
import style2 from "./scss/newStandard.scss?vue&type=style&index=2&id=075e9908&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075e9908",
  null
  
)

export default component.exports